"use client";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { Accordion } from "@/components/ui/accordion";
import { FilterNav } from "@/components";
import { cn } from "@/lib/utils";
import { useState } from "react";

export function FilterDrawer({
  categories,
  setActiveCategories,
  activeCategories,
  singleSelect = false,
  tagItems = [],
  setActiveTags,
  activeTags = [],
  tagSingleSelect = false,
}) {
  const [open, setOpen] = useState(false);
  const selected = activeCategories ?? [];
  const tagSelected = activeTags ?? [];
  const filterCount =
    selected.length + (setActiveTags ? tagSelected.length : 0);
  const showTags = tagItems.length > 0 && typeof setActiveTags === "function";
  const showCategories = categories?.length > 0;
  const sectionCount = (showTags ? 1 : 0) + (showCategories ? 1 : 0);
  const singleSection = sectionCount <= 1;

  function clearAllFilters() {
    setActiveCategories?.([]);
    setActiveTags?.([]);
  }

  const filters = (
    <>
      {showTags && (
        <FilterNav
          filterName="Entries"
          items={tagItems}
          setActiveItems={setActiveTags}
          activeItems={tagSelected}
          asCheckbox
          alwaysOpen={singleSection}
          containOpen={!singleSection}
          singleSelect={tagSingleSelect}
        />
      )}
      {showCategories && (
        <FilterNav
          filterName="Categories"
          items={categories}
          setActiveItems={setActiveCategories}
          activeItems={selected}
          asCheckbox
          alwaysOpen={singleSection}
          containOpen={!singleSection}
          singleSelect={singleSelect}
        />
      )}
    </>
  );

  return (
    <Drawer
      direction="bottom"
      open={open}
      onOpenChange={setOpen}
      shouldScaleBackground={false}
    >
      <DrawerTrigger className="lg:hidden" asChild>
        <Button size="lg" variant="outline">
          Filter {filterCount > 0 && `(${filterCount})`}
        </Button>
      </DrawerTrigger>
      <DrawerContent className="h-[80vh] max-h-[80vh] px-4 py-4">
        <div
          className={cn(
            "flex h-full min-h-0 w-full flex-col overflow-hidden",
          )}
          style={{
            "--button-background": "137 33 2",
            "--button-hover-background": "137 33 2",
            "--button-foreground": "255 255 255",
          }}
        >
          {singleSection ? (
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
              {filters}
            </div>
          ) : (
            <Accordion
              type="single"
              collapsible
              defaultValue="Categories"
              className="flex w-full min-h-0 flex-1 flex-col overflow-hidden"
            >
              {filters}
            </Accordion>
          )}
          <div className="grid shrink-0 grid-cols-2 gap-3 border-t-2 border-brand-fawn pt-4">
            <Button variant="outline" onClick={clearAllFilters}>
              Clear all filters
            </Button>
            <Button onClick={() => setOpen(false)}>Show results</Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
